import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { cn } from "../../../../util/cn";

interface ParcelBookingTicketProps {
  className?: string;
}

const ParcelBookingTicket: React.FC<ParcelBookingTicketProps> = ({
  className,
}) => {
  const { t } = useTranslation();
  const selectedLocation = useSelector(
    (state: RootState) => state.bookingCreation.selectedLocation
  );
  const orderData = useSelector(
    (state: RootState) => state.bookingCreation.orderData
  );
  const hasSkippedLockeSelection = useSelector(
    (state: RootState) => state.booking.hasSkippedLockeSelection
  );

  const selectedGroup = useSelector(
    (state: RootState) => state.bookingCreation.selectedGroup
  );

  const textBoldClass =
    "text-foreground/80 font-bold leading-5 tracking-[0.02em] break-words";

  return (
    <div
      className={cn(
        "bg-background shadow-md flex flex-col py-8 px-5 border border-foreground/10 relative mx-5 rounded-md text-foreground",
        className
      )}
    >
      {/* Ticket perforations */}
      <div className="absolute right-0 top-[29%] w-[5px] h-[10px] bg-primary rounded-l-full" />
      <div className="absolute left-0 top-[29%] w-[5px] h-[10px] bg-primary rounded-r-full" />

      <div className="flex flex-col gap-4">
        {/* Location Information */}
        <div>
          <p className="text-sm text-gray-600 mb-1">
            {t("book_location.booking_summary.location", "Delivery Location")}
          </p>
          <p className={textBoldClass}>
            {selectedLocation?.address
              ? `${selectedLocation.address.street}, ${selectedLocation.address.postalCode} ${selectedLocation.address.city}`
              : "Musterweg 1, 23422 Hamburg"}
          </p>
        </div>
        {!hasSkippedLockeSelection && (
          <>
            {/* Delivery Date */}
            <div>
              <p className="text-sm text-gray-600 mb-1">
                {t(
                  "book_location.booking_summary.delivery_date",
                  "Expected Delivery Date"
                )}
              </p>
              <p className={textBoldClass}>
                {orderData?.date?.format("DD.MM.YYYY") || "28.08.2025"}
              </p>
            </div>

            {/* Package Details */}
            <div>
              <p className="text-sm text-gray-600 mb-1">
                {t(
                  "book_location.booking_summary.package_details",
                  "Package Details"
                )}
              </p>
              <div className="flex justify-between items-center">
                <span className={textBoldClass}>
                  {t("book_location.booking_summary.package_size", "Size")}:{" "}
                  {selectedGroup?.name || "M"}
                </span>
              </div>
              {selectedGroup?.description && (
                <p className="text-xs text-foreground/60 mt-1">
                  {selectedGroup.description}
                </p>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ParcelBookingTicket;
